import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { applyStoredAppearance } from "./app/appearance.js";
import "./styles.css";
import "./features/landing/buyer-refinement.css";
import "./styles/appearance-extras.css";

applyStoredAppearance();

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
